
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.5","height":"15.615"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.344 7.331C24.125 7.031 18.91 0 12.25 0S.374 7.032.155 7.331a.808.808 0 000 .953c.219.3 5.434 7.331 12.094 7.331s11.876-7.032 12.094-7.331a.807.807 0 00.001-.953zM12.25 14C7.344 14 3.095 9.333 1.837 7.807c1.256-1.527 5.5-6.192 10.413-6.192s9.155 4.666 10.413 6.193C21.407 9.335 17.167 14 12.25 14z"}}),_c('path',{attrs:{"d":"M12.25 2.962a4.846 4.846 0 104.846 4.846 4.852 4.852 0 00-4.846-4.846zm0 8.077a3.231 3.231 0 113.231-3.231 3.234 3.234 0 01-3.231 3.229z"}})])
          )
        }
      }
    